<template>
  <div class="search-bar">
    <div class="space-y-2" :class="{ 'gray-lighten-2 rounded-md p-2': !noWrapper }">
      <div v-if="$slots['before']">
        <slot name="before" />
      </div>
      <div class="flex items-center space-x-2">
        <div v-if="$slots['before-input']" class="grow">
          <slot name="before-input" />
        </div>
        <div class="w-full grow-0">
          <slot>
            <PFormField label="Zoeken" sr-only>
              <PInput
                v-bind="$attrs"
                :model-value="modelValue"
                @update:model-value="emit('update:modelValue', $event ?? '')"
                type="search"
                :placeholder="($attrs.placeholder as string | undefined) ?? 'Zoeken'"
                ref="searchInputRef"
              >
                <template #leading>
                  <FontAwesomeIcon :icon="['fas', 'magnifying-glass']" />
                </template>
              </PInput>
            </PFormField>
          </slot>
        </div>
        <div v-if="$slots['after-input']" class="grow">
          <slot name="after-input" />
        </div>
      </div>
      <div v-if="$slots['after']">
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, onMounted } from "vue"
import PInput from "@/components/form/PInput.vue"
import PFormField from "@/components/form/PFormField.vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

const props = withDefaults(
  defineProps<{
    modelValue: string
    noWrapper?: boolean
    noAutoFocus?: boolean
  }>(),
  {
    noWrapper: false,
    noAutoFocus: false
  }
)

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits<{
  "update:modelValue": [value: string]
}>()

const searchInputRef = ref<InstanceType<typeof PInput> | null>(null)

function focus() {
  nextTick(() => {
    searchInputRef.value?.focus()
  })
}

defineExpose({
  focus
})

onMounted(() => {
  // Focus the input when the component is mounted
  if (!props.noAutoFocus) {
    focus()
  }
})
</script>
